export default "__VITE_ASSET__BYfA9jvz__"